module.exports = __webpack_public_path__ + "img/chatbot.e6748b73.svg";